import Section from './ui/Section.jsx';
import Eyebrow from './ui/Eyebrow.jsx';
import Reveal from './ui/Reveal.jsx';
import CredentialList from './CredentialList.jsx';
import { credentials } from '../data/credentials.js';

export default function About() {
  return (
    <Section id="over" label="02 Over mij">
      <div
        className="section-grid-2"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 96,
          alignItems: 'flex-start',
        }}
      >
        <Reveal>
          <Eyebrow>Over mij</Eyebrow>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 400,
              fontSize: 'clamp(36px, 4vw, 56px)',
              lineHeight: 1.1,
              letterSpacing: '-0.01em',
              color: 'var(--ink)',
              margin: '14px 0 24px',
            }}
          >
            Maxime Duisterhof,
            <br />
            <span style={{ fontStyle: 'italic' }}>GZ psycholoog.</span>
          </h2>
          <div
            style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 400,
              fontSize: 17,
              lineHeight: 1.75,
              color: 'var(--ink-2)',
              maxWidth: '52ch',
            }}
          >
            <p>
              Ik ben afgestudeerd psycholoog aan de Vrije Universiteit van Amsterdam en
              postdoctoraal opgeleid tot Gezondheidszorgpsycholoog (BIG). Ik heb mij gespecialiseerd
              in interpersoonlijke psychotherapie, CGT, EMDR, ACT, schematherapie en MBCT.
            </p>
            <p style={{ marginTop: 18 }}>
              De kennis uit deze opleidingen integreer ik in de sessies, afgestemd op de behoeften
              en problematiek van de cliënt. Ik zie elke cliënt als een losstaand individu, met zijn
              of haar eigen krachten en kwaliteiten — die persoonlijke benadering maakt elke
              behandeling anders.
            </p>
            <p style={{ marginTop: 18 }}>
              Naast mijn eigen online praktijk werk ik bij <em>Oh My Mood</em> in Amsterdam, een
              holistische instelling met een transdiagnostische werkwijze.
            </p>
          </div>
        </Reveal>

        <Reveal
          delay={140}
          className="credentials-card"
          style={{
            background: 'var(--cream-2)',
            borderRadius: 'var(--radius-md)',
            padding: '36px 36px',
            boxShadow: 'var(--shadow-card)',
          }}
        >
          <Eyebrow>Opleidingen</Eyebrow>
          <div style={{ marginTop: 20 }}>
            <CredentialList items={credentials} />
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
